import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { GenericError } from '@startuptools/ui/Error';
import { Divider } from '@startuptools/ui/Divider';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Link } from '@startuptools/ui/Link';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { OnboardingUserProfileEdit } from './OnboardingUserProfileEdit';
import { Outlet, Routes, Route, Navigate } from 'react-router-dom';
import { Trans, useLingui } from '@lingui/react';
import { logout } from '@startuptools/auth/ng';
import { ProfileMenu } from '@startuptools/business-ui/profile-menu/ProfileMenu';
import { Suspense } from 'react';
import { switchLang } from '../helpers/switch-lang';
import { OnboardingCreateCompany } from './OnboardingCreateCompany';
import { StatusNotification } from '../components/status/StatusNotification';
import { useCurrentUserSuspenseQuery } from '../graphql/react-operations';
import { TermsMenuItem } from '@startuptools/business-ui/profile-menu/menu-items/TermsMenuItem';
import { LogoutMenuItem } from '@startuptools/business-ui/profile-menu/menu-items/LogoutMenuItem';
import { SwitchLangMenuItem } from '@startuptools/business-ui/profile-menu/menu-items/SwitchLangMenuItem';
import { Avatar } from '@startuptools/ui/joy/Avatar';
import { Typography } from '@startuptools/ui/joy/Typography';
import { useNavigate } from '../components/Navigate';

const OnboardingInner = () => {
  const {
    data: { currentUser },
  } = useCurrentUserSuspenseQuery();
  const { i18n } = useLingui();
  return (
    <Stack alignItems="center" maxHeight="100dvh">
      <Box sx={{ width: '100%' }}>
        <Stack direction="row" gap={1} height={48} bgcolor="white" alignItems="center" justifyContent="space-between">
          <Stack direction="row" gap={2}>
            <Box sx={{ height: 30, padding: 2 }}>
              <img src="./assets/logo/bolago-black.svg" height="30px" alt="logo" />
            </Box>
            <Link underline="none" href="https://help.startuptools.org" target="_blank">
              <Button variant="outlined" color="neutral" startDecorator={<HelpOutlineIcon />}>
                <Trans id="Help" />
              </Button>
            </Link>
            <StatusNotification />
          </Stack>
          <Stack direction="row">
            <ProfileMenu
              identityDisplayProps={{
                name: currentUser.name,
                secondRow: currentUser.email,
                startDecorator: (
                  <Avatar variant="solid" color="primary" size="sm">
                    <Typography level="title-md" sx={{ color: 'white' }}>
                      {currentUser.name?.[0]}
                    </Typography>
                  </Avatar>
                ),
              }}
            >
              <SwitchLangMenuItem lang={i18n.locale as 'en' | 'sv'} switchLang={switchLang} />
              <TermsMenuItem />
              <Divider />
              <LogoutMenuItem onClick={logout} />
            </ProfileMenu>
          </Stack>
        </Stack>
        <Divider />
      </Box>
      <Stack px={4} maxHeight="100%" width="100dvw" alignItems="center" sx={{ overflowX: 'auto' }}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

const Onboarding = () => {
  return (
    <Suspense>
      <OnboardingInner />;
    </Suspense>
  );
};

export const OnboardingRoutes = () => {
  const { pathname } = useNavigate();
  if (pathname.endsWith('onboarding')) {
    return <Navigate to="create-company" replace />;
  }

  return (
    <Routes>
      <Route path="" element={<Onboarding />}>
        <Route
          path="profile"
          element={<OnboardingUserProfileEdit />}
          errorElement={
            <Card sx={{ padding: 2, margin: 2 }}>
              <GenericError />
            </Card>
          }
        />
        <Route
          path="create-company"
          element={<OnboardingCreateCompany />}
          errorElement={
            <Card sx={{ padding: 2, margin: 2 }}>
              <GenericError />
            </Card>
          }
        />
      </Route>
    </Routes>
  );
};
